var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1728813292243,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5099,
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 512C0 229.2224 229.2224 0 512 0s512 229.2224 512 512-229.2224 512-512 512S0 794.7776 0 512z",
    fill: "#52C41A",
    "p-id": 5100
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M824.7296 424.7552a56.832 56.832 0 0 0-80.4352-80.384l-281.5488 281.4464-160.8192-160.8192a56.832 56.832 0 1 0-80.4352 80.384l200.4992 200.5504a56.832 56.832 0 0 0 81.92-0.4096l320.8192-320.768z",
    fill: "#FFFFFF",
    "p-id": 5101
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.13b40c06e87f8be0e481653336b23282.svg";
export { ForwardRef as ReactComponent };